import React, { useState, useEffect } from "react";
import { Loader } from "../../common/Loader";
import { usePaymentController } from "../../apis/PaymentGateway";
import toast from "react-hot-toast";
import { useAuth } from "../../context/UserContext";
import { EditCart, getCoupon, PaymentMethod } from "../../apis/Api";
import { useNavigate } from "react-router-dom";
import { useWalletContext } from "../../context/walletContext";

function CartItem({
  loading,
  setLoading,
  refreshing,
  setRefreshing,
  error,
  setError,
  fetchDevices,
  devices,
  setDevices,
  address,
  totalPrice,
  updateTrigger,
  setUpdateTrigger,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(2);
  const [totalPages, setTotalPages] = useState(1);
  const { handlePlaceBooking } = usePaymentController();
  const [coupon, setCoupon] = useState([]);
  const { user } = useAuth();
  const navigate = useNavigate();
  const { useWallet, setUseWallet, appliedCoupon, setAppliedCoupon } =
    useWalletContext();
  const userWallet = user ? parseInt(user[0]?.wallet || 0) : 0;
  const numericTotalPrice = Number(totalPrice.replace(/[^0-9.-]+/g, ""));
  //const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponError, setCouponError] = useState(null);

  const applyCoupon = (coupon) => {
    setCouponError(null);
    if (!coupon?.discount) {
      setCouponError("Invalid coupon format");
      return;
    }
    const isPercentage =
      typeof coupon.discount === "string" && coupon.discount.includes("%");
    let discountValue;
    if (isPercentage) {
      const percentageMatch = coupon.discount.match(/(\d+)%/);
      if (!percentageMatch) {
        setCouponError("Invalid percentage format");
        return;
      }
      discountValue = parseInt(percentageMatch[1]);
    } else {
      discountValue = Number(coupon.discount);
      if (isNaN(discountValue)) {
        setCouponError("Invalid discount value");
        return;
      }
    }

    if (discountedTotal < coupon.min_order_value) {
      setCouponError(`Minimum order of ₹${coupon.min_order_value} required`);
      return;
    }
    setAppliedCoupon({
      ...coupon,
      discountValue,
      isPercentage,
    });

    document.getElementById("couponOffcanvas")?.classList.remove("show");
    toast.success("Coupon applied successfully!");
  };
  // console.log("applied",appliedCoupon)

  const discountedTotal = useWallet
    ? Math.max(numericTotalPrice - (Number(userWallet) || 0), 0)
    : numericTotalPrice;

  const couponDiscount = appliedCoupon
    ? appliedCoupon.isPercentage
      ? (discountedTotal * appliedCoupon.discountValue) / 100
      : Math.min(appliedCoupon.discountValue, discountedTotal)
    : 0;

  const finalTotal = Math.max(discountedTotal - couponDiscount, 0);
  const removeCoupon = () => {
    setAppliedCoupon(null);
    toast.success("Coupon removed successfully!");
  };

  useEffect(() => {
    if (devices && devices.length > 0) {
      setTotalPages(Math.ceil(devices.length / itemsPerPage));
    }
  }, [devices, itemsPerPage, updateTrigger]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const PostUpdateCart = async (p_token, price) => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("no user found");
      }
      const cart = [
        {
          token: `${p_token}`,
          price: `${price}`,
        },
      ];
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error("Request timed out")), 10000)
      );

      const responsePromise = EditCart({
        cust_token: token,
        Cart: cart,
        totalPrice: totalPrice,
      });
      const response = await Promise.race([responsePromise, timeoutPromise]);

      if (response.status === 200) {
        toast.success("Order updated successfully!");
        setUpdateTrigger((prev) => prev + 1);
      }
    } catch (error) {
      console.log("Error updating cart:", error);

      setError(error.message || "Failed to update orders. Please try again.");
      setDevices([]);
      toast.error("update failed");
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  const sumtotalPrice =
    devices?.reduce(
      (total, device) =>
        total +
        device.product.reduce(
          (sum, service) => sum + parseFloat(service.payable_price),
          0
        ),
      0
    ) || 0;

  const [showModal, setShowModal] = useState(false);

  const placeBooking = () => {
    setShowModal(true);
  };

  const handlePaymentChoice = async (choice) => {
    setShowModal(false);
    if (choice === "online") {
      try {
        const token = localStorage.getItem("token");
        const data = {
          cust_token: token,
          pay_method: "online",
          user: user[0],
          totalPrice: finalTotal,
        };
        const response = await handlePlaceBooking(data);
        if (response.status == 200) {
          toast.success("order placed");
          navigate(`/confirm-order/${response.order_id}`);
        } else {
          throw new Error("order failed");
        }
      } catch (error) {
        toast.error("failed to place order");
      }
    } else {
      try {
        const token = localStorage.getItem("token");
        const data = {
          cust_token: token,
          pay_method: "cash",
          totalPrice: finalTotal,
          order_token: devices ? devices[0].order_token : "",
        };

        const response = await PaymentMethod(data);

        if (response.status === 200) {
          toast.success(
            "Order placed successfully! Please complete your payment offline."
          );
          navigate(`/confirm-order/${response.order_id}`);
        } else {
          throw new Error("Order placement failed");
        }
      } catch (error) {
        toast.error("Failed to place order. Please try again.");
      }
    }
  };
  const getCurrentItems = () => {
    if (!devices) return [];
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return devices.slice(indexOfFirstItem, indexOfLastItem);
  };

  const fetchCoupon = async () => {
    const cust_token = localStorage.getItem("token");
    try {
      const response = await getCoupon({ cust_token });
      console.log(response);
      if (response?.status === 200) {
        const data = response.data;
        console.log("Coupon fetched successfully:", data);
        setCoupon(data);
      } else {
        console.error("Failed to fetch coupon: Invalid response");
      }
    } catch (error) {
      console.error("Failed to fetch coupon:", error.message);
    }
  };

  useEffect(() => {
    fetchCoupon();
  }, []);
  if (loading && !refreshing) {
    return (
      <div className="container my-5">
        <div className="row">
          <div className="col-md-12 d-flex justify-content-center">
            <Loader />
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container my-5">
        <div className="row">
          <div className="col-md-12 d-flex justify-content-center flex-column align-items-center">
            <h5>{error}</h5>
            <button className="btn btn-success mt-3" onClick={fetchDevices}>
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container my-5">
      <div className="row mb-4">
        <div className="col-12">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title mb-0">
                Showing {getCurrentItems()?.length || 0} device
                {getCurrentItems()?.length !== 1 ? "s" : ""} out of{" "}
                {devices?.length || 0} total in cart
              </h5>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-8">
          <div
            className={`row ${
              getCurrentItems()?.length === 1 ? "justify-content-center" : ""
            }`}
          >
            {getCurrentItems()?.map((brand, index) => (
              <div key={index} className="col-md-6 mb-3">
                <div className="card shadow-sm h-100">
                  <img
                    src={brand.phone_url}
                    alt={brand.brand_name}
                    className="card-img-top p-2"
                    style={{ maxHeight: "120px", objectFit: "contain" }}
                  />
                  <div className="card-body text-center">
                    {/* <h6 className="card-title fw-bold">{brand.brand_name}</h6> */}
                    <p className="mb-1">
                      Model: <strong>{brand.model_name}</strong>
                    </p>
                    {/* <p className="mb-1">
                      Color: <strong>{brand.color_name}</strong>
                    </p> */}
                    <p class="mb-0">
                      Color: <strong>Genuine</strong>
                    </p>
                    <h6 className="fw-bold">Repair Service</h6>

                    <div
                      className={`row ${
                        brand?.product?.length === 1
                          ? "justify-content-center"
                          : ""
                      }`}
                    >
                      {brand?.product.map((service, idx) => (
                        <div key={idx} className="col-6 mb-2">
                          <div className="border p-2 rounded text-center shadow-sm ">
                            <img
                              src={service.url}
                              alt={service.product_name}
                              className="img-fluid mb-2"
                              style={{ maxHeight: "40px" }}
                            />
                            <div className="fw-bold text-capitalize">
                              {service.product_name}
                            </div>
                            <div>
                              <span className="fw-bold">
                                ₹{service.payable_price}
                              </span>
                              <span className="old-price ms-1 text-muted">
                                ₹{service.main_price}
                              </span>
                            </div>
                            <span
                              onClick={() => {
                                PostUpdateCart(
                                  service.token,
                                  service.payable_price
                                );
                              }}
                              style={{
                                color: "red",
                                cursor: "pointer",
                                marginLeft: "10px",
                              }}
                            >
                              🗑️
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          {devices && devices.length > itemsPerPage && (
            <div className="d-flex justify-content-center mt-4">
              <nav aria-label="Page navigation">
                <ul className="pagination">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                      aria-label="Previous"
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </button>
                  </li>

                  {[...Array(totalPages)].map((_, index) => (
                    <li
                      key={index}
                      className={`page-item ${
                        currentPage === index + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(index + 1)}
                      >
                        {index + 1}
                      </button>
                    </li>
                  ))}

                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                      aria-label="Next"
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>

        <div className="col-md-4">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title border-bottom pb-3">Price Summary</h5>
              <div className="d-flex flex-column text-capitalize fw-bold py-3">
                {devices &&
                  devices.map((device, index) => (
                    <div key={index} className="mb-3">
                      <div className="d-flex justify-content-between w-100 mb-2">
                        <div className="d-flex align-items-center gap-2">
                          <span className="badge bg-light text-primary px-2">
                            {index + 1}
                          </span>
                          <span>
                            {device.model_name} {device.color_name}{" "}
                          </span>
                        </div>
                        <span className="text-dark fw-bold">
                          ₹
                          {device.product.reduce(
                            (sum, service) =>
                              sum + parseFloat(service.payable_price),
                            0
                          )}
                        </span>
                      </div>
                      {device.inventoryAvailable === false && (
                        <div className="text-danger">
                          Inventory Not Available
                        </div>
                      )}
                    </div>
                  ))}
              </div>
              <div className="d-flex justify-content-between align-items-center fw-bold mb-3">
                <span>Total Amount</span>
                <span className="text-dark fs-5">
                  ₹{parseInt(discountedTotal)}
                </span>
              </div>
              {appliedCoupon && (
                <>
                  <div className="d-flex justify-content-between align-items-center fw-bold mb-2">
                    <span>Coupon Discount ({appliedCoupon.discount}%)</span>
                    <span className="text-success">
                      -₹{parseInt(couponDiscount)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="text-muted small">
                      {appliedCoupon.title}
                    </span>
                    <button
                      onClick={removeCoupon}
                      className="btn btn-sm btn-outline-danger"
                      style={{ height: "35px", width: "100px" }}
                    >
                      Remove
                    </button>
                  </div>
                </>
              )}

              <div className="d-flex justify-content-between align-items-center fw-bold mb-3 border-top pt-2">
                <span>Final Amount</span>
                <span className="text-dark fs-4">₹{finalTotal}</span>
              </div>
              {couponError && (
                <div className="alert alert-danger py-2 mb-3">
                  {couponError}
                </div>
              )}

              <button
                onClick={placeBooking}
                className="book-now-btn w-100 d-flex justify-content-between align-items-center"
              >
                <span>Book Now</span>
                <span>→</span>
              </button>

              <div class="d-flex justify-content-between align-items-center py-3">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="useWallet"
                    checked={useWallet}
                    onChange={() => setUseWallet(!useWallet)}
                  />
                  <label class="form-check-label fw-bold" for="useWallet">
                    Use Wallet
                  </label>
                </div>
                <span class="text-success fw-bold">
                  ₹{user ? user[0].wallet : "0"}
                </span>
              </div>
              <button
                className="btn btn-primary my-3"
                data-bs-toggle="offcanvas"
                data-bs-target="#couponOffcanvas"
                style={{
                  height: "35px",
                  width: "150px",
                  backgroundColor: "#73b734  ",
                }}
              >
                Show Coupons
              </button>
              <div
                className="offcanvas offcanvas-end"
                id="couponOffcanvas"
                tabIndex="-1"
                aria-labelledby="offcanvasLabel"
                data-bs-backdrop="false"
              >
                <div className="offcanvas-header">
                  <h5
                    className="offcanvas-title"
                    id="offcanvasLabel"
                    style={{ color: "#73b734", fontWeight: "bold" }}
                  >
                    Available Coupons
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="offcanvas"
                  ></button>
                </div>
                <div className="offcanvas-body">
                  {coupon.length > 0 ? (
                    coupon.map((item, index) => (
                      <div
                        key={index}
                        className="p-2 border rounded shadow-sm d-flex align-items-center justify-content-between"
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderLeft: "5px solid #73b734",
                          marginBottom: "10px",
                        }}
                      >
                       
                        <h6 className="fw-bold m-0" style={{ flex: "1" }}>
                          {item.title}
                        </h6>
                        <p
                          className="m-0 px-2"
                          style={{ color: "red", fontWeight: "bold" }}
                        >
                          {item.coupon_code}
                        </p>
                        <span
                          className="badge"
                          style={{
                            color: "#73b734",
                            fontSize: "14px",
                          }}
                        >
                          {item.code}
                        </span>
                        <span
                          className="badge"
                          style={{
                            backgroundColor: "#73b734",
                            color: "white",
                            fontSize: "14px",
                            marginLeft: "10px",
                          }}
                        >
                          {item.discount}% Off
                        </span>
                        <button
                          className="btn ms-2"
                          style={{
                            backgroundColor: "#73b734",
                            color: "white",
                            fontWeight: "bold",
                            height: "35px",
                            width: "75px",
                          }}
                          onClick={() => applyCoupon(item)}
                        >
                          Apply
                        </button>
                      </div>
                    ))
                  ) : (
                    <p className="text-center">No coupons available</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Select Payment Method</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body text-center">
                <button
                  className="btn btn-success m-2"
                  onClick={() => handlePaymentChoice("online")}
                  style={{ height: "35px", width: "120px" }}
                >
                  Pay Online
                </button>
                <button
                  className="btn btn-secondary m-2"
                  onClick={() => handlePaymentChoice("offline")}
                  style={{ height: "35px", width: "160px" }}
                >
                  Cash On delivery
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CartItem;
